"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventDispatcher = function () {
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);
  }

  _createClass(EventDispatcher, [{
    key: "dispatchEvent",
    value: function dispatchEvent(threeObject, eventName) {
      var eventCallbacks = threeObject.userData._eventCallbacks;
      var callback = eventCallbacks && eventCallbacks[eventName];

      if (callback) {
        for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          params[_key - 2] = arguments[_key];
        }

        callback.apply(undefined, params);
      }
    }
  }]);

  return EventDispatcher;
}();

module.exports = EventDispatcher;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-three-renderer/lib/utils/EventDispatcher.js
 ** module id = 799
 ** module chunks = 0
 **/